module.exports = __webpack_public_path__ + "static/media/iphone-img-dashboard.4a64916e.svg";